import { createAction, props } from '@ngrx/store';

export const getCRMOffersApi = createAction(
  '[CRM Component API] Load CRM Offers'
);

export const getCRMOffersSuccess = createAction(
  '[CRM Component] Load CRM Offers Success',
  props<{ offers: any | null }>()
);

export const getCRMOffersFailure = createAction(
  '[CRM Component] Load CRM Offers Failure',
  props<{ error: any }>()
);

export const selectActiveCRMOffer = createAction(
  '[CRM Component API] Select CRM Offer',
  props<{ selectedCRMOffer: any }>()
);

